import { render, staticRenderFns } from "./bmap.vue?vue&type=template&id=0b3a66ee&scoped=true"
import script from "./bmap.vue?vue&type=script&lang=js"
export * from "./bmap.vue?vue&type=script&lang=js"
import style0 from "./bmap.vue?vue&type=style&index=0&id=0b3a66ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a66ee",
  null
  
)

export default component.exports